import React, { useEffect, useState } from "react";
import DashboardHeader from "../../../Components/header/DashboardHeader";
import "./Overview.css";
import {
  atom,
  avatar,
  card_imgs,
  card_marvins,
  dummyCard,
  live_groups_vdo,
  Nano_techno,
  star,
} from "../../../assets";
import { Link, useNavigate } from "react-router-dom";
import { AiFillLike, AiOutlineLike } from "react-icons/ai";
import { FaRegCommentDots } from "react-icons/fa";
import { RiShareForwardLine } from "react-icons/ri";
import { HiDotsVertical } from "react-icons/hi";
import { Dropdown, Offcanvas } from "react-bootstrap";
import { fetchCategoriesListApi } from "../../../services/common";
import { useSelector } from "react-redux";
import { CiSearch } from "react-icons/ci";
import useShimmer from "../../../hooks/useShimmer";
import InterestedCategoriesShimmer from "../../../shimmer/interestedCategories/InterestedCatgeories";
import SideDrawer from "../../../Components/sideDrower/SideDrawer";
import { GoArrowRight } from "react-icons/go";
import { fetchOverviewListApi } from "../../../services/overview";
import moment from "moment";
import { reactions } from "../../../utils/staticData";
import { feedDetailApi, feedReactionApi } from "../../../services/feeds";
import { toastMessage } from "../../../utils/toastMessage";
import OverviewComment from "./section/OverviewComment";
import { handleCopy } from "../../../utils/copyClipboard";
import InfiniteScroll from "react-infinite-scroll-component";
import OverviewReport from "./section/OverviewReport";
import OverviewListShimmer, {
  LiveShimmer,
} from "../../../shimmer/overview/OverviewListshimmer";
import useDebounce from "../../../hooks/useDebounce";
import { getCheckLiveApi } from "../../../services/groupMember";
import { encryptData } from "../../../utils/dataCipher";
import Slider from "react-slick";
import DeleteFeed from "./section/DeleteFeed";
import { overViewDetailsLink } from "../../../utils/shareLink";


const Overview = () => {
  const { showAuth } = useSelector((state) => state?.showAuth);
  const [categoryList, setCategoryList] = useState([]);
  const [overviewList, setOverviewList] = useState([]);
  const [pageLoader, setPageLoader] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [reportModal, setReportModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [hasMore, setHasMore] = useState(true);
  const [search, setSearch] = useState("");
  const debouncedValue = useDebounce(search, 300);
  const [page, setPage] = useState(1);
  const [live, setLive] = useState("");
  const navigate = useNavigate();
  // console.log('categoryList', categoryList)
  //---------#--------------
  useEffect(() => {
    setCategoryList(showAuth?.interestedCategories);
  }, [showAuth?.interestedCategories]);
  // ---------handle-commit------------
  const handleComment = (data) => {
    setSelectedData(data);
    setCommentModal(true);
  };
  // ---------handle-commit------------
  const handleReport = (data) => {
    setSelectedData(data);
    setReportModal(true);
  };
  // ---------handle-Delete------------
  const handleDelete = (data) => {
    setSelectedData(data);
    setDeleteModal(true);
  };
  // -----------handle-reaction-API---------------------
  const handleFeedsReaction = async (reaction, feedData) => {
    try {
      setSelectedData(feedData || {});
      const { data } = await feedReactionApi({
        _feed: feedData?._id,
        reaction,
      });
      const { success, message } = data;
      if (success) {
        getFeedDetail(feedData?._id);
      } else {
        //-------error-message-show-only---------
        toastMessage(message, success ? "success" : "error", "handleFeedsReaction");
      }
    } catch (e) {
      console.error(e.message);
    }
  };
  //----------feed-details-api---------------
  const getFeedDetail = async (_id) => {
    try {
      const { data } = await feedDetailApi({ _id });
      const { success, message, data: response } = data;
      if (success) {
        // Find the item in categoryList
        const findIndex = overviewList?.findIndex((data) => data?._id === _id);
        if (findIndex !== -1) {
          setOverviewList((prev) =>
            prev.map((item, index) => (index == findIndex ? response : item))
          );
        }
      } else {
        toastMessage(message, "error", "getFeedDetail");
      }
    } catch (e) {
      console.error("Error:-", e.message);
    }
  };

  //-------------overview-list-------------------
  const fetchOverviewList = async (page = 1, isRefresh = false) => {
    try {
      const { data } = await fetchOverviewListApi({
        pagination: true,
        limit: 9,
        page,
        search: debouncedValue,
      });
      const { success, message, data: response } = data;
      if (success) {
        if (isRefresh) {
          setOverviewList(response);
        } else {
          setOverviewList((prev) => [...prev, ...response]);
        }
        setHasMore(response.length === 9);
      } else {
        toastMessage(message, "error", "errorOverView");
      }
    } catch (e) {
      console.error("Error fetching overview list:", e.message);
      setHasMore(false);
    }
  };

  useEffect(() => {
    setPage(1);
    setHasMore(true);
    fetchOverviewList(1, true);
  }, [debouncedValue]);

  const fetchMoreData = () => {
    setPage((prevPage) => {
      const nextPage = prevPage + 1;
      fetchOverviewList(nextPage);
      return nextPage;
    });
  };
  //-----------check-here-live-or-not-----------------
  useEffect(() => {
    const getLiveCheck = async () => {
      try {
        setPageLoader(true);
        const response = await getCheckLiveApi();
        if (response?.data?.success) {
          setLive(response?.data?.data?.userLive);
        }
      } catch (e) {
        console.log("Error:-", e.message);
      } finally {
        setPageLoader(false);
      }
    };
    getLiveCheck();
  }, []);
  var settings = {
    autoplay: true,
    autoplaySpeed: 4000,
    dots: true,
    infinite: false,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  // //-----------check-here-live-or-not-----------------
  // const getLiveCheck = async () => {
  //   try {
  //     const response = await getCheckLiveApi()
  //     if (response?.data?.success) {
  //       setLive(response?.data?.data?.userLive)
  //     }
  //   } catch (e) {
  //     console.log("Error:-", e.message);
  //   }
  // };
  // console.log('overviewList', overviewList)

  return (
    <>
      <DashboardHeader title={"Overview"} />
      <div className="over_view">
        <div className="over_view_header">
          <div className="over_view_tabs_card">
            {categoryList?.map((data, ind) => (
              <div
                key={ind}
                className="menu-bars active"
                onClick={() =>
                  navigate(
                    `/dashboard/category/group-list?info=${encryptData({
                      ...data,
                      type: "overview",
                    })}`
                  )
                }
              >
                <Link to={""} className="menu-item" key={data?._id}>
                  <img src={data?.image} alt="Technology Icon" />
                  {data?.name}
                </Link>
              </div>
            ))}
          </div>
          <div className="search_overview">
            <CiSearch />

            <input
              type="text"
              className="input form-control"
              placeholder="Search here"
              value={search || ""}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
        {/* -----------live-group---------------------- */}
        {pageLoader ? (
          <LiveShimmer />
        ) : (
          String(live) !== "0" && (
            <div className="live_group_parent">
              <div className="live_group_left">
                <img src={live_groups_vdo} />
                <div className="live_grp_txt">
                  <b>All Live Groups</b>
                  <p>
                    The groups that live streaming currently will appear here.
                  </p>
                </div>
              </div>
              <div className="live_group_right">
                <Link to={"/dashboard/overview/live-details"}>
                  <GoArrowRight className="live_group_icon" />
                </Link>
              </div>
            </div>
          )
        )}
        {/* Infinite Scroll Section */}
        <InfiniteScroll
          dataLength={overviewList.length}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={<OverviewListShimmer count={9} />}
          endMessage={
            <p style={{ textAlign: "center", margin: "25px" }}>
              <b>No more data to display</b>
            </p>
          }
        >
          {/* ----------------card-section--------------------- */}
          <div className="cards_container">
            {overviewList && overviewList.length > 0
              ? overviewList.map((card, index) => (
                <div className="_card" key={card._id}>
                  <div className="_cards_header">
                    <div className="cardtop_header">
                      <img
                        src={card?._group?.coverImage || avatar}
                        alt={card?.createdBy?.fullName}
                      />
                      <div className="info">
                        <div className="name">
                          {card?._group?.name || "N/A"}
                        </div>
                        <div className="time">
                          {card?.createdBy?.fullName && (
                            <>
                              Posted by{" "}
                              {card?._group?.settings?.anonymousPosting
                                ? "Anonymous"
                                : card?.createdBy?.fullName}{" "}
                              - {moment(card?.createdAt).fromNow()}
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    <Dropdown>
                      <Dropdown.Toggle id="dropdown-basic">
                        <HiDotsVertical />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {card?.createdBy?._id === showAuth?._id ? (
                          <>
                            <Dropdown.Item
                              as={Link}
                              to={`/dashboard/feed/edit-feed/${card?._id}`}
                            >
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item onClick={() => handleDelete(card)}>
                              Delete
                            </Dropdown.Item>
                          </>
                        ) : (
                          <Dropdown.Item onClick={() => handleReport(card)}>
                            Report
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>

                  <div className="card_image">
                    <Link to={`/dashboard/overview/detail/${card?._id}`}>
                      <div className="upload_cover">
                        <div className="slider_banner">
                          <Slider {...settings}>
                            {card?.attachments &&
                              card.attachments.length > 0 ? (
                              card.attachments.map((data, ind) => (
                                <div
                                  key={ind}
                                  className="upload_design_content overwrite_upload_design_content"
                                >
                                  {data.type === "VIDEO" ? (
                                    <video
                                      controls
                                      width="100%"
                                      poster={data.thumbnailUrl}
                                    >
                                      <source
                                        src={data.url}
                                        type="video/mp4"
                                      />
                                      Your browser does not support the video
                                      tag.
                                    </video>
                                  ) : (
                                    <img
                                      className="mqwertyu"
                                      src={data.url}
                                      alt="attachment"
                                    />
                                  )}
                                </div>
                              ))
                            ) : (
                              <div className="upload_design_content overwrite_upload_design_content">
                                <img src={dummyCard} alt="attachment" />
                              </div>
                            )}
                          </Slider>
                        </div>
                      </div>
                      <span className="tag">
                        {card?._group?.categoryName || "N/A"}
                      </span>
                    </Link>
                  </div>

                  <Link to={`/dashboard/overview/detail/${card?._id}`}>
                    <div className="card_content">
                      <h3>{card?.title || "N/A"}</h3>
                    </div>
                  </Link>




                  <div className="card_footer">
                    <button className="card_footer_btn">
                      {reactions?.map((reactionData, ind) => (
                        <span
                          key={ind}
                          className="me-2"
                          onClick={() =>
                            handleFeedsReaction(reactionData?.name, card)
                          }
                        >
                          {card?.myReaction?.[reactionData?.name]
                            ? reactionData?.fillEmoji
                            : reactionData?.emoji}
                          {card?.reactions?.[reactionData?.name] || ""}
                        </span>
                      ))}
                    </button>

                    <button
                      className="card_footer_btn"
                      onClick={() => handleComment(card)}
                    >
                      <FaRegCommentDots /> Comments
                    </button>
                    <button
                      onClick={() => handleCopy(`${overViewDetailsLink}${card?._id}`)}
                      className="card_footer_btn"
                    >
                      <RiShareForwardLine /> Share
                    </button>
                  </div>
                </div>
              ))
              : null}
          </div>
        </InfiniteScroll>
      </div>

      {/* ---------comments--------------------- */}
      <OverviewComment
        show={commentModal}
        close={() => setCommentModal(false)}
        selectedData={selectedData}
      />
      {/* ---------report--------------------- */}
      <OverviewReport
        show={reportModal}
        close={() => setReportModal(false)}
        selectedData={selectedData}
        pageName="Post"
        type="FEED"
      />
      {/* //-----------feed-request----------------- */}
      {deleteModal && (
        <DeleteFeed
          show={deleteModal}
          close={() => setDeleteModal(false)}
          scroll={true}
          listing={fetchOverviewList}
          id={selectedData?._id}
          feedName={selectedData?._group?.name}
          setPage={setPage}
          setHasMore={setHasMore}
        />
      )}
    </>
  );
};

export default Overview;
